// import 'core-js/modules/es7.promise.finally';
import Vue from "vue";
import App from "@/App.vue";
import "@/styles/app.scss";
import Toasted from "vue-toasted";
import VueRouter from "vue-router";
import ModelParserMixin from "@/mixins/ModelParser";
import RouteHelpersMixin from "@/mixins/RouteHelpers";
import RequestsMixin from "@/mixins/http/RequestsMixin";
import DisplayErrors from "@/components/DisplayErrors.vue";
import VIcon from "@/components/VIcon.vue";
import "@/initializers";
import router from "@/router";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import store from "@/store";
import VContentLoading from "@/components/VContentLoading.vue";
import VueNumeric from "vue-numeric";
import DateTimeFilter from "@/filters/DateTime";
import moment from "moment";

declare module "vue/types/vue" {
  interface Vue {
    $mq: string;
    $parseModel(list: any | any[]): any;
    $getModelRoutes(name: string): any;
    $httpGet(
      url: string,
      tag: string,
      fields?: string[] | string,
      require?: string,
    ): Promise<any>;
    $httpPost(url: string, tag: string, data: any): Promise<any>;
    $httpPut(url: string, tag: string, data: any): Promise<any>;
    $httpDelete(url: string, tag: string, data: any): Promise<any>;
    $isRouteActive(route: string): boolean;
    $areRouteActive(routes: string[]): boolean;
    $moment: typeof moment;
  }
}

Vue.component("fa-icon", FontAwesomeIcon);
Vue.component("v-loading", VContentLoading);

Vue.use(VueRouter);
Vue.use(VueNumeric);
window.addEventListener("load", () => {
  Vue.use(Toasted);
});
Vue.filter("currency", function (value: number, currency: string) {
  let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
  });
  return formatter.format(value);
});
Vue.filter("dateTime", DateTimeFilter);
Vue.component("v-icon", VIcon);
Vue.component("display-errors", DisplayErrors);
Vue.mixin(ModelParserMixin);
Vue.mixin(RouteHelpersMixin);
Vue.mixin(RequestsMixin);

document.addEventListener("DOMContentLoaded", () => {
  const app = new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount();
  document.body.appendChild(app.$el);
});
